<!--
 * @description: 科普殿堂 文章详情
 * @Author: Jay
 * @Date: 2021-09-24 15:42:52
 * @LastEditors: Jay
 * @LastEditTime: 2021-10-16 14:10:55
-->
<template>
  <div>
    <!-- 顶部Tab 切换 -->
    <TopTab></TopTab>
    <!-- 页面内容 -->
    <div class="fix-width">
      <div class="text-align font_size_xxl font_weight_bold padding-top">
        {{ title }}
      </div>
      <div class="padding flex self-center justify-center">
        <div v-html="article"></div>
      </div>
    </div>
    <!-- 底部边距 -->
    <div class="height-al"></div>
    <!-- 底部信息 -->
    <root-bottom></root-bottom>
  </div>
</template>

<script>
// 顶部Tab 切换
import TopTab from "@/components/tab/top-tab.vue";
// 底部信息
import rootBottom from "@/components/bottom/root-bottom.vue";
// import marked from "marked";
// import 'mavon-editor/dist/css/index.css'
export default {
  name: "PalaceDetails",
  data() {
    return {
      title: "",
      article: "",
    };
  },
  mounted() {
    //动态修改文章标题
    document.title = this.title;
  },
  computed: {
    // compiledMarkdown() {
    //   // console.log(this.article);
    //   // return marked(this.article, { sanitize: true });
    //   // return marked(this.article || "");
    // },
  },
  created() {
    let ifData = this.$store.state.articleConter;
    // console.log(ifData);
    if (ifData != "") {
      this.title = ifData.name;
      this.article = ifData.content;
      //设置 临时 缓存
      const rowObj = JSON.stringify(ifData);
      sessionStorage.setItem("article", rowObj);
    } else {
      let info = JSON.parse(window.sessionStorage.getItem("article"));
      // console.log(info);
      this.title = info.name;
      this.article = info.content;
    }
  },
  methods: {},
  //页面销毁
  updated() {
    // this.$store.state.articleConter = [];
  },
  components: {
    TopTab,
    rootBottom,
  },
};
</script>

<style lang="scss" scoped>
// class="meeting-detail-intro"
// .meeting-detail-intro {
//   ::v-deep {
//     img {
//       max-width: 100%;
//     }
//   }
// }
</style>
